export const MsgType = {
    info: 'info',
    success: 'success',
    warning: 'warning',
    error: 'error'
}


export const DeleteType = {
    User: 0,
    Project: 1,
    Category: 2,
    Company: 3,
    Topic:4,
    Task: 5
}

// چرخه وظیفه - باید دقیقا با Control/Enumuration.cs یکی بماند
export const TaskStateType = {
    /// <summary>
    /// ثبت اولیه - هنوز به کارشناس اعلام نشده
    /// </summary>
    Registered: 0,

    /// <summary>
    /// در انتظار اجرا - به کارشناس اعلام شده
    /// </summary>
    Waiting: 1,

    /// <summary>
    /// در حال انجام
    /// </summary>
    Doing: 2,

    /// <summary>
    /// انجام داده - کارشناس اعلام کرده تمام شده
    /// </summary>
    Delivered: 3,

    /// <summary>
    /// تایید شده - فقط مدیر
    /// </summary>
    Approved: 4,

    /// <summary>
    /// لغو شده - فقط مدیر، و به کارشناس نمایش داده نمی شود
    /// </summary>
    Canceled: 5,

    /// <summary>
    /// برگشت خورده - مدیر تایید نکرده
    /// </summary>
    Rejected: 6,

    /// <summary>
    /// فقط موارد باز - قرارداد موجود همین پروژه
    /// </summary>
    OnlyOpen: 99,

    /// <summary>
    /// همه وضعیت ها
    /// </summary>
    All: -1
}

// چه کسی وظیفه را تعریف کرده - سرور از روی نقش پر می کند، فرم چیزی نمی پرسد
export const TaskSourceType = {
    Manager: 0,
    Agent: 1
}

// کارشناس روی هر وظیفه فقط یک حرکت بعدی دارد. این دو تابع همان قانونی را
// می گویند که سرور در IsAgentAllowedTransition دارد، تا دکمه ای نشان داده
// نشود که کلیکش خطا می دهد.
export const CanAgentStart = (state) =>
    state === TaskStateType.Waiting || state === TaskStateType.Rejected;

export const CanAgentDeliver = (state) =>
    state === TaskStateType.Doing;


export const StateType = {
    /// <summary>
    /// ثبت اولیه
    /// </summary>
    Insert: 0,


    /// <summary>
    /// در دست بررسی
    /// </summary>
    Checking: 1,


    /// <summary>
    /// پاسخ داده شده است
    /// </summary>
    Answer: 2,

    /// <summary>
    /// بسته شده
    /// </summary>
    Close: 3,
    ///<summary>
    /// در صف انتظار اجرا
    ///</summary>
    WaitingList: 4
}